import { Button } from "@flat-ui";
import { useCompanyId } from "@context-providers/company-id-provider";
import { useAppNavigation } from "@hooks/navigation/use-app-navigation";
import { useShouldShowAddCredits } from "@hooks/use-should-show-add-credits";
import { CREDITS_DISPLAY_NAME } from "@src/constants/credit-constants";
import { WorkspaceEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";

/** Component to show the button add credits */
export function AddCredits(): JSX.Element | null {
  const { trackEvent } = useTrackEvent();
  const companyId = useCompanyId();
  const { navigateToCreditsPage } = useAppNavigation();
  const { shouldShowAddCredits } = useShouldShowAddCredits();

  if (!shouldShowAddCredits) {
    return null;
  }

  function handleAddCredits(): void {
    trackEvent({
      name: WorkspaceEvents.openAddCreditsPage,
    });

    // Navigate to the add credits page
    navigateToCreditsPage({ companyId });
  }

  return <Button onClick={handleAddCredits}>Add {CREDITS_DISPLAY_NAME}</Button>;
}
